import React, { useState, useRef } from 'react';
import Icon_info from "../images/IconCheckError.svg";
import { SelectPicker, Modal, Whisper, Tooltip, Button, DatePicker } from "rsuite";
import 'rsuite/dist/rsuite.min.css';
import "rsuite/DatePicker/styles/index.css";
import IconInfo from "../images/Icon_Info.svg";
import IconUser from "../images/log-activity-icons/iconUser.svg";
import IconDollar from "../images/log-activity-icons/icon-dollar.svg";
import IconTimer from "../images/log-activity-icons/iconTimer.svg";
import IconTimerFill from "../images/log-activity-icons/iconTimerFill.svg";
import IconTrigger from "../images/log-activity-icons/iconTrigger.png";
import IconWarning from "../images/log-activity-icons/iconWarning.png";
import { CircleFlag } from 'react-circle-flags';

import iconList from '../images/log-activity-icons/iconList.svg';
import iconCall from '../images/log-activity-icons/iconCall.svg';
import iconEmail from '../images/log-activity-icons/iconMail.svg';
import iconSms from '../images/log-activity-icons/iconSMS.svg';
import iconWhatsapp from '../images/log-activity-icons/iconWhatsapp.svg';
import iconMeeting from '../images/log-activity-icons/iconMeeting.svg';

import iconDropArrow from '../images/log-activity-icons/iconDropArrow.svg';
import iconCollapseArrow from '../images/log-activity-icons/iconCollapseArrow.svg';



const icons = {
    Task: iconList,
    Call: iconCall,
    Email: iconEmail,
    SMS: iconSms,
    Whatsapp: iconWhatsapp,
    Meeting: iconMeeting,
    Summit: iconMeeting,
};

const typeColors = {
    Task: "#C032B2",      // Gray
    Call: "#1FB16E",      // Blue
    Email: "#5CABF3",     // Teal
    SMS: "#FF9012",       // Orange
    Whatsapp: "#1FB16E",  // WhatsApp Green
    Meeting: "#F03D3D",   // Purple
    Summit: "#F03D3D",    // Green
};

const LeadModal = () => {
    const [LogActiveitiCallModalOpen, setLogActiveitiCallModalOpen] = useState(false);
    const [assignStatus, setAssignStatus] = useState(null);
    const [isLoading, setIsLoading] = useState(false);

    const statusOptions = [
        { label: 'Completed', value: 'completed' },
        { label: 'Waiting for Reply', value: 'waiting' },
        { label: 'Call Back Needed', value: 'callback' },
        { label: 'No Answer', value: 'noanswer' }
    ];

    const handleReassignSave = () => {
        setIsLoading(true);
        setTimeout(() => {
            setIsLoading(false);
            setLogActiveitiCallModalOpen(false);
        }, 1000);
    };

    // const handleEditModalClose = () => {
    //     setLogActiveitiCallModalOpen(false);
    // };

    const statusOptionsData = [
        { label: 'Completed', value: 'completed', color: '#1FB16E' },
        { label: 'Waiting for Reply', value: 'waiting', color: '#FF9012' },
        { label: 'Call Back Needed', value: 'callback', color: 'blue' },
        { label: 'No Answer', value: 'noanswer', color: '#D80027' }
    ];

    // DATEPICKER
    const [filterDate, setFilterDate] = useState(null);
    // Tabs
    const [activeTab, setActiveTab] = useState('log');

    // HISTORY TAB
    const [show, setShow] = useState(false);
    const [expandedMonths, setExpandedMonths] = useState([]);
    const [expandedItems, setExpandedItems] = useState({});

    const toggleMonth = (month) => {
        setExpandedMonths((prev) =>
            prev.includes(month) ? prev.filter((m) => m !== month) : [...prev, month]
        );
    };

    const toggleItem = (month, index) => {
        setExpandedItems((prev) => ({
            ...prev,
            [month]: {
                ...prev[month],
                [index]: !prev[month]?.[index],
            },
        }));
    };

    const historyData = {
        "Upcoming & Overdue": [
            {
                type: "Task",
                time: "No due date",
                details: null,
            },
        ],

        "June • 2025": [
            {
                type: "Call",
                time: "7:00 PM | Jun 15",
                details: {
                    start: "6 / 12 / 2025, 7:00 PM",
                    end: "6 / 12 / 2025, 7:10 PM",
                    input: true,
                },
            },
            {
                type: "Email",
                time: "9:00 PM | Jun 14",
                details: null,
            },
        ],
        "May • 2025": [
            {
                type: "SMS",
                time: "8:00 PM | May 2",
                details: null,
            },
        ],
        "April • 2025": [
            {
                type: "Whatsapp",
                time: "3:00 PM | April 19",
                details: null,
            },
            {
                type: "Meeting",
                time: "3:00 PM | April 19",
                details: { input: true },
            },
        ],
        "March • 2025": [
            {
                type: "Summit",
                time: "1:00 PM | March 19",
                details: {
                    input: true,
                    location: true,
                },
            },
        ],
    };


      const [EditModalOpen, setEditModalOpen] = useState(false);
        const handleEditModalClose = () => setEditModalOpen(false);

    return (
        <>

            <Button type="button" class="btn btn-primary" onClick={() => setEditModalOpen(true)}>
                Big Modal
            </Button>

            <Button type="button" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#NewInvestorLeadModal">
                Small Modal
            </Button>

            <Modal open={EditModalOpen} onClose={handleEditModalClose} className='modal fade log_activity_call_modal' aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className='activity_modal_body_header'>
                            <ul className='log_activity_tabs'>
                                <li className={` ${activeTab === 'log' ? 'active' : ''
                                    }`}
                                    onClick={() => setActiveTab('log')}>Log Activity</li>
                                <li className={` ${activeTab === 'history' ? 'active' : ''
                                    }`}
                                    onClick={() => setActiveTab('history')}>History</li>
                            </ul>
                            <div className='activity_modal_body_header_right'>
                                <p>Assigned To</p>
                                <div className="log_activity_select">
                                    <SelectPicker
                                        data={statusOptions}
                                        searchable={false}
                                        style={{ width: 300 }}
                                        placeholder="Select Status"
                                        value={assignStatus}
                                        onChange={setAssignStatus}
                                        menuClassName="log_activity_select_dropdown"
                                        container={() => document.querySelector('.modal-body')}
                                    />
                                </div>
                            </div>
                        </div>
                        <div class="modal-body log_activity_call_modal_body">
                            {activeTab === 'log' && (
                                <div className="tab_content_section">
                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>Status & Timing</div>
                                        <p>Investor: <span className='dark__grey__text'>Mirwais Yousifzai</span></p>
                                        <p>Invited At: <span className='dark__grey__text'>5 June 2025, 10:13 PM</span></p>
                                        <p>Investor's Local Time: <span className='dark__grey__text'>07:34:28 PM (USA)</span></p>
                                        <p>Time Since Invite: <span className='dark__green__text'>4m 32s</span><span className='green__dot'></span></p>
                                        <p>Time Since Invite: <span className='dark__orange__text'>10m 32s</span><span className='orange__dot'></span></p>
                                        <p>Time Since Invite: <span className='dark__red__text'>10m 32s</span><span className='red__dot'></span></p>
                                        <p>Escalation Status: <span className='dark__grey__text'>On Track (within 5-minute SLA)</span></p>

                                        <div className='reason_notify_row'>
                                            <p><span className='triangle__shape triangle__red'></span> Escalation Triggered <span>– No contact after 10 minutes</span></p>
                                            <p><span className='triangle__shape triangle__orange'></span> Risk: <span>Investor may not invest anymore</span></p>
                                            <p>Action: <span>Add reason for delay and notify manager</span></p>

                                            <div className='reason_notify_btn__group'>
                                                <button className='btn__reason_for_delay'>Reason for Delay</button>
                                                <button className='btn__notify_manager'>Notify Manager</button>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>Investor Snapshot</div>
                                        <p>Investor Status: <span className='dark__grey__text'>New</span></p>
                                        <p>Accredited Status: <span className='dark__grey__text'>Yes</span></p>
                                        <p>Investment Likelihood Score: <span className='dark__grey__text'>99</span><span className='green__dot'></span></p>
                                        <p>Subscription Type: <span className='dark__grey__text'>Freemium</span></p>
                                        <p>Days Since Subscription: <span className='dark__grey__text'>5</span></p>
                                        <p>Activity Score: <span className='dark__grey__text'>86</span><span className='green__dot'></span><span className='modal_icon__info'><img src={IconInfo} /></span></p>
                                    </div>

                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>Communication Details</div>
                                        <ul className='log_activity_CD_tabs'>
                                            <li className='active'>Call</li>
                                            <li>SMS</li>
                                            <li>Whats App</li>
                                            <li>Email</li>
                                            <li>Meeting</li>
                                            <li>Other</li>
                                        </ul>

                                        <div className='row'>
                                            <div className='col-md-4 mt-4'>
                                                <label>Call Type</label>
                                                <div className="log_activity_select">
                                                    <SelectPicker
                                                        data={statusOptions}
                                                        searchable={false}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select Status"
                                                        value={assignStatus}
                                                        onChange={setAssignStatus}
                                                        menuClassName="log_activity_select_dropdown"
                                                        container={() => document.querySelector('.modal-body')}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-4 mt-4'>
                                                <label>Status</label>
                                                <div className="log_activity_select">
                                                    <SelectPicker
                                                        data={statusOptionsData}
                                                        searchable={false}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select Status"
                                                        value={assignStatus}
                                                        onChange={setAssignStatus}
                                                        menuClassName="log_activity_select_dropdown"
                                                        container={() => document.querySelector('.modal-body')}
                                                        renderMenuItem={(label, item) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span
                                                                    style={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: item.color
                                                                    }}
                                                                ></span>
                                                                <span>{label}</span>
                                                            </div>
                                                        )}
                                                        renderValue={(value, item) => (
                                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                                <span
                                                                    style={{
                                                                        width: 8,
                                                                        height: 8,
                                                                        borderRadius: '50%',
                                                                        backgroundColor: item?.color
                                                                    }}
                                                                ></span>
                                                                <span>{item?.label}</span>
                                                            </div>
                                                        )}
                                                    />
                                                </div>

                                            </div>
                                        </div>
                                    </div>

                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>Outcome & Follow-Up</div>
                                        <div className='row'>
                                            <div className='col-md-12 mt-4'>
                                                <label>Interaction Summary</label>
                                                <textarea rows={3} className='form-control textarea_form_log_activity'></textarea>
                                            </div>

                                            <div className='col-md-6 mt-4'>
                                                <label>Outcome</label>
                                                <div className="log_activity_select">
                                                    <SelectPicker
                                                        data={statusOptions}
                                                        searchable={false}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select Status"
                                                        value={assignStatus}
                                                        onChange={setAssignStatus}
                                                        menuClassName="log_activity_select_dropdown"
                                                        container={() => document.querySelector('.modal-body')}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-6 mt-4'>
                                                <label>Priority Level</label>
                                                <div className="log_activity_select">
                                                    <SelectPicker
                                                        data={statusOptions}
                                                        searchable={false}
                                                        style={{ width: '100%' }}
                                                        placeholder="Select Status"
                                                        value={assignStatus}
                                                        onChange={setAssignStatus}
                                                        menuClassName="log_activity_select_dropdown"
                                                        container={() => document.querySelector('.modal-body')}
                                                    />
                                                </div>
                                            </div>

                                            <div className='col-md-6 mt-4'>
                                                <label>Initial Investment Interest Amount</label>
                                                <div className="log_activity_select cutom_input_with_info cutom_input_with_info_disabled">
                                                    <input type='text' value="$50000" />
                                                    <button><img src={IconInfo} /></button>
                                                </div>
                                            </div>

                                            <div className='col-md-6 mt-4'>
                                                <label>Updated Investment Interest Amount</label>
                                                <div className="log_activity_select cutom_input_with_btn">
                                                    <input type='text' className='' />
                                                    <button>Results</button>
                                                </div>
                                            </div>

                                            <div className='col-md-6 mt-4'>
                                                <label>Follow-Up Plan</label>
                                                <input type='text' className='form-control log_activity_select log_activity_input_italic' placeholder='Type here' />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>Notes & Scheduling</div>
                                        <div className="log_activity_calendar_row">
                                            <div className="form-check">
                                                <input
                                                    className="form-check-input"
                                                    type="checkbox"
                                                    id="ScheduleFollowUp"
                                                />
                                                <label className="form-check-label" htmlFor="ScheduleFollowUp">
                                                    Schedule Follow-Up
                                                </label>
                                            </div>

                                            <div className="log_activity_select log_activity_calendar">
                                                <DatePicker
                                                    oneTap
                                                    showMeridian
                                                    style={{ width: '100%' }}
                                                    placeholder="Choose Date"
                                                    format="dd-MM-yyyy"
                                                    value={filterDate}
                                                    container={() => document.querySelector('.modal-body')}
                                                    onChange={(value) => {
                                                        console.log("Selected:", value);
                                                        setFilterDate(value);
                                                    }}
                                                />
                                            </div>

                                            <div className="log_activity_select log_activity_calendar">
                                                <input type="text" readOnly />
                                            </div>

                                            <a href='#' className=''>Attach Supporting Materials</a>
                                        </div>

                                        <a href='#' className='mt-4'>Attach Supporting Materials</a>
                                    </div>

                                    <div className='log_activity_call_section'>
                                        <div className='log_activity_call_title'>System Info</div>
                                        <div className='text_create_and_modify'>
                                            <p><span>Created By:</span> Dilshod Bek, 28 April 2025, 10:49 AM</p>
                                            <p><span>Last Modified By:</span> Dilshod Bek, 28 April 2025, 10:49 AM</p>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {activeTab === 'history' && (
                                <div className="tab_content_section tab_content_section_history">
                                    {/* History by Month */}


                                    {Object.entries(historyData).map(([month, entries]) => (
                                        <div key={month} className="tab_content_section_history_wrap">
                                            <div
                                                className="history_section_title d-flex justify-content-between align-items-center"
                                                style={{ cursor: "pointer" }}
                                                onClick={() => toggleMonth(month)}
                                            >
                                                {month}
                                                <span>
                                                    <img
                                                        style={{ transition: 'transform 0.3s ease' }}
                                                        src={expandedMonths.includes(month) ? iconDropArrow : iconCollapseArrow}
                                                        alt="toggle"
                                                        width={20}
                                                        height={20}
                                                    />

                                                    {/* {expandedMonths.includes(month) ? "▾" : "▸"} */}
                                                </span>
                                            </div>

                                            <div
                                                className={`entry-container transition-container ${expandedMonths.includes(month) ? 'expanded' : ''}`}
                                            >
                                                {entries.map((entry, idx) => {
                                                    const isExpanded = expandedItems[month]?.[idx];
                                                    return (
                                                        <div
                                                            key={idx}
                                                            className="border-startX border-2 ps-3 position-relative history_main_row"
                                                            style={{ borderLeft: `2px solid ${typeColors[entry.type] || "#ccc"}`, }}
                                                        >
                                                            {/* Line + Dot (Timeline style) */}
                                                            <div
                                                                style={{
                                                                    position: "absolute",
                                                                    top: -2,
                                                                    left: -53,
                                                                    width: 80,
                                                                    height: 55,
                                                                    background: '#FFF',
                                                                    display: 'flex',
                                                                    alignItems: 'center',
                                                                    justifyContent: 'start',
                                                                    gap: '10px',
                                                                    cursor: 'pointer',

                                                                }}
                                                                onClick={() => toggleItem(month, idx)}
                                                            >
                                                                <span style={{ fontSize: 14 }}>
                                                                    <img
                                                                        style={{ transition: 'transform 0.3s ease' }}
                                                                        src={isExpanded ? iconDropArrow : iconCollapseArrow}
                                                                        alt="toggle"
                                                                        width={20}
                                                                        height={20}
                                                                    />
                                                                </span>
                                                                <img
                                                                    src={icons[entry.type]}
                                                                    alt={entry.type}
                                                                    width={50}
                                                                    height={50}
                                                                    style={{ objectFit: 'contain' }}
                                                                /></div>


                                                            <div className="history_under_tab d-flex justify-content-between">
                                                                <div style={{ width: '100%' }}>
                                                                    {month === "Upcoming & Overdue" ? (
                                                                        <>
                                                                            <div className='d-flex justify-content-between'>
                                                                                <div>
                                                                                    <div className="d-flex align-items-center gap-2">
                                                                                        <input
                                                                                            type="checkbox"
                                                                                            className="form-check-input"
                                                                                            id={`checkbox-${month}-${idx}`}
                                                                                        />
                                                                                        <label
                                                                                            htmlFor={`checkbox-${month}-${idx}`}
                                                                                            className="history_under_head m-0"
                                                                                            style={{ cursor: "pointer" }}
                                                                                            onClick={() => toggleItem(month, idx)}
                                                                                        >
                                                                                            Call John Doe tomorrow
                                                                                        </label>
                                                                                    </div>

                                                                                    <div className="text-muted history_under_desc">You had task</div>
                                                                                </div>
                                                                                <div className="text-muted history_under_date">{entry.time}</div>

                                                                            </div>
                                                                        </>
                                                                    ) : (
                                                                        <>

                                                                            <div className='d-flex justify-content-between'>
                                                                                <div
                                                                                    className="history_under_head"
                                                                                    style={{ cursor: "pointer" }}
                                                                                    onClick={() => toggleItem(month, idx)}
                                                                                >
                                                                                    {entry.type}
                                                                                </div>

                                                                                <div className="text-muted history_under_date">{entry.time}</div>
                                                                            </div>


                                                                            <div className="text-muted history_under_desc">
                                                                                {`You had ${entry.type.toLowerCase()}`}
                                                                            </div>
                                                                        </>
                                                                    )}

                                                                    {/* Description, Start/End, Location — common for both */}
                                                                    <div className={`expandable-wrapper ${isExpanded ? "open" : ""}`}>
                                                                        {isExpanded && entry.details && (
                                                                            <>
                                                                                <div className="mt-4 d-flex gap-4">
                                                                                    {entry.details.start && (
                                                                                        <div className='history_date'>
                                                                                            <span className='medium_text'>Start:</span> {entry.details.start}
                                                                                        </div>
                                                                                    )}
                                                                                    {entry.details.end && (
                                                                                        <div className='history_date'>
                                                                                            <span className='medium_text'>End:</span> {entry.details.end}
                                                                                        </div>
                                                                                    )}
                                                                                </div>
                                                                                <div className="mt-2 pb-3">
                                                                                    {entry.details.input && (
                                                                                        <textarea
                                                                                            className="form-control form__control__modal"
                                                                                            placeholder="Description"
                                                                                        ></textarea>
                                                                                    )}
                                                                                    {/* {entry.details.location && (
                                                                                        <input className="form-control form__control__modal" placeholder="Location" />
                                                                                    )} */}
                                                                                </div>
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                </div>


                                                            </div>

                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}

                        </div>

                        <div className="modal-footer">
                            <button type="button" className="btn_cancel_log_activity" data-bs-dismiss="modal">Cancel</button>
                            <button className="btn__save_log_activity" onClick={handleReassignSave} loading={isLoading}>Save</button>
                        </div>
                    </div>
                </div>
            </Modal>

            {/* <div className='modal fade new_investor_lead_modal' id="NewInvestorLeadModal" aria-hidden="true">
                <div class="modal-dialog modal-dialog-scrollable">
                    <div class="modal-content">
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div className='new_investor_lead_header'>
                            <h3>New Investor Lead – High Priority</h3>
                            <p>Reach out within 5 minutes to maximize conversion</p>
                        </div>

                        <div class="modal-body new_investor_lead_modal_body">
                            <div className='new_investor_lead_section'>
                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconUser} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Name: <span className='medium_text'>John Abdullah</span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <CircleFlag countryCode='us' style={{ width: 24, height: 24 }} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Country: <span className='medium_text'>USA</span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconDollar} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Investment Interest: <span className='medium_text'>$25,000</span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconTimerFill} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Priority: <span className='medium_text dark__green__text'>High</span> <span className='green__dot'></span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconTimer} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Time Since Invite: <span className='medium_text dark__green__text'>2m 12s</span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconWarning} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Escalation Warning – <span className='sbold_text'>Follow-up window exceeded!</span>
                                    </div>
                                </div>

                                <div className='new_investor_lead_row'>
                                    <div className='new_investor_lead_icon'>
                                        <img src={IconTrigger} />
                                    </div>
                                    <div className='new_investor_lead_text'>
                                        Escalation Triggered – <span className='sbold_text'>No contact after 10 minutes</span>
                                    </div>
                                </div>

                                <button className='btn__contact_investor_now'>Contact Investor Now</button>

                                <div className='reassing_to_row'>
                                    <p>Reassign To:</p>
                                    <div className="log_activity_select">
                                        <SelectPicker
                                            data={statusOptions}
                                            searchable={false}
                                            style={{ width: '100%' }}
                                            placeholder="Select Status"
                                            value={assignStatus}
                                            onChange={setAssignStatus}
                                            menuClassName="log_activity_select_dropdown"
                                            container={() => document.getElementById('NewInvestorLeadModal')}
                                        />
                                    </div>
                                </div>

                                <div className='reason_notify_btn__group pt-2'>
                                    <button className='btn__notify_manager'>Yes, Reassign</button>
                                    <button className='btn__reason_for_delay'>Cancel</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </>
    );
};

export default LeadModal;
